import "bootstrap/dist/js/bootstrap.js";
import "@/assets/icons.scss";
import "@/assets/style.scss";
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { store, key } from "./store";
import { createI18n } from "vue-i18n";
import en from "@/lang/en-US.json";
import ru from "@/lang/ru-RU.json";
import he from "@/lang/he-IL.json";
import { api } from "./services/Api";
import PrimeVue from 'primevue/config';
import Ripple from 'primevue/ripple';
import 'primevue/resources/primevue.min.css';
import 'primevue/resources/themes/saga-blue/theme.css';
import 'primeicons/primeicons.css';
import mixin from '@/mixin';
import './registerServiceWorker'

import "jquery/dist/jquery.min.js";
import $ from "jquery";

import "@progress/kendo-ui/js/kendo.all"; // This will import the entire Kendo UI library
// As an alternative, you could import only the scripts that are used by a specific widget:
// import '@progress/kendo-ui/js/kendo.scheduler' // Imports only the Scheduler script and its dependencies
import "@/assets/kendo.scss";

// import '@progress/kendo-theme-default/dist/all.scss';

// REQUIRED FOR TYPES (ts)
import { Scheduler } from "@progress/kendo-scheduler-vue-wrapper";
import addKendoLocale from './services/kendo.locales';
import mitt from 'mitt';
import { getOrInitPrinterSettings } from "./utils/printer";
const emitter = mitt();

function setDir(lang: string) {
  const body = document.querySelector("body");
  const dir = lang == "he-IL" ? "rtl" : "ltr";
  body?.classList.add(dir);
  body?.setAttribute("dir", dir);
}

(async (): Promise<void> => {
  const printerSettings = await getOrInitPrinterSettings();
  const initResponse = await api.withLoader().init();
  if (initResponse.data) {
    store.commit("init", initResponse.data);
    store.commit("setPrinterSettings", printerSettings);
    store.commit("updateLang", initResponse.data.lang);
    store.dispatch("startTime");
  }

  setDir(initResponse.data?.lang || "en-US");

  const i18n = createI18n({
    locale: initResponse.data?.lang,
    legacy: false,
    globalInjection: true,
    fallbackLocale: "en-US",
    messages: {
      'en-US': en,
      'he-IL': he,
      'ru-RU': ru
    }
  });

  // const { prompt } = usePWA();
  // prompt(i18n.global.t);

  addKendoLocale(i18n.global);

  const app = createApp(App);
  app.mixin({
    mixins: [mixin]
  });
  app.use(i18n);
  app.use(store, key);
  app.use(router);
  app.use(PrimeVue, { ripple: true });
  app.directive('ripple', Ripple);
  app.provide('emitter', emitter);
  app.mount("#app");
})();
